<div class="mention-container" #editorContainer (keydown)="onKeyDown($event)">
  <angular-editor
    [(ngModel)]="htmlContent"
    [config]="editorConfig"
    (ngModelChange)="onContentChange($event)"
    (keydown)="onEditorKeyDown($event)"
    class="mention-editor"></angular-editor>

  @if (showDropdown && !appendToBody) {
    <div
      class="mention-dropdown"
      [style.top.px]="dropdownPosition.top"
      [style.left.px]="dropdownPosition.left">
      <div *ngIf="isLoading && filteredUsers.items.length === 0" class="mention-loading">
        <i class="fas fa-spinner fa-spin"></i>
        <span>{{ '::Loading' | abpLocalization }}</span>
      </div>
      <ng-container *ngIf="!isLoading && filteredUsers.items.length === 0">
        <div class="mention-empty">{{ '::NoDataFound' | abpLocalization }}</div>
      </ng-container>
      <div class="mention-items">
        <div
          *ngFor="let user of filteredUsers.items; let i = index"
          class="mention-item"
          [class.active]="i === selectedIndex"
          (click)="selectUser(user)"
          (mouseenter)="selectedIndex = i">
          <ng-container *ngIf="itemTemplate; else defaultTemplate">
            <ng-container
              *ngTemplateOutlet="itemTemplate; context: { $implicit: user }"></ng-container>
          </ng-container>
          <ng-template #defaultTemplate>
            <ca-user-identity
              [id]="user.id"
              [name]="user.fullname"
              [surname]="user.surname"
              [item]="user.fullname"></ca-user-identity>
          </ng-template>
        </div>
      </div>
      <mat-paginator
        *ngIf="totalCount > pageSize"
        [length]="totalCount"
        [pageSize]="pageSize"
        [pageIndex]="pageIndex"
        (page)="onPageChange($event)"
        hidePageSize
        showFirstLastButtons></mat-paginator>
    </div>
  }
</div>

<ng-template #dropdownTemplate>
  <div class="mention-dropdown mention-dropdown-body">
    <div *ngIf="isLoading && filteredUsers.items.length === 0" class="mention-loading">
      <i class="fas fa-spinner fa-spin"></i>
      <span>{{ '::Loading' | abpLocalization }}</span>
    </div>
    <ng-container *ngIf="!isLoading && filteredUsers.items.length === 0">
      <div class="mention-empty">{{ '::NoDataFound' | abpLocalization }}</div>
    </ng-container>
    <div class="mention-items">
      <div
        *ngFor="let user of filteredUsers.items; let i = index"
        class="mention-item"
        [class.active]="i === selectedIndex"
        (click)="selectUser(user)"
        (mouseenter)="selectedIndex = i">
        <ng-container *ngIf="itemTemplate; else defaultTemplate">
          <ng-container
            *ngTemplateOutlet="itemTemplate; context: { $implicit: user }"></ng-container>
        </ng-container>
        <ng-template #defaultTemplate>
          <ca-user-identity
            [id]="user.id"
            [name]="user.fullname"
            [surname]="user.surname"
            [item]="user.fullname"></ca-user-identity>
        </ng-template>
      </div>
    </div>
    <mat-paginator
      *ngIf="totalCount > pageSize"
      [length]="totalCount"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      (page)="onPageChange($event)"
      hidePageSize
      showFirstLastButtons></mat-paginator>
  </div>
</ng-template>
